import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-tooltip', 'open', 'Open tooltip');
Labels.set('ui-tooltip', 'close', 'Close tooltip');
